import { render, staticRenderFns } from "./PageOrders.vue?vue&type=template&id=2b017dc0"
import script from "./PageOrders.vue?vue&type=script&lang=js"
export * from "./PageOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports